/*!
 * @Author: leo
 * @Date: 2020-04-20 12:02:00
 * @Last Modified by: Robin
 * @Last Modified time: 2024-06-29 11:00:51
 * @Instruduction: 联系记者接口
 */

import xhr from './xhr/index'

interface IGetContactsParams {
    status?: string // 跟进状态
    type?: string // 联系事由
    cert_status?: string // 认领状态
    user_id?: string // 用户id
    page_index?: number // 第几页
    page_size?: number // 每页条数
    paid?: number | string // (n)是否付费报料 0:否 1:是
    province?: string // (n)省
    city?: string // (n)市
    created_at_gte?: string // 创建时间大于等于
    created_at_lte?: string // 创建时间小于等于
}

interface IGetContactParams {
    id: number // 联系 ID
}

interface IUpdateContactParams {
    id: number // 联系 ID
    followStatus: number // 跟进状态
    pdUserId: string // 负责人 ID
    memo: string // 跟进备注
}

interface IPushToReporterParams {
    reporter_id: number // 记者id
    contact_id: string // 联系申请的id
}

interface IGetOrderListParams {
    status?: number // 支付状态 0:未支付 1:已支付 (不传则不过滤)
    page_index?: number // 第几页
    page_size?: number // 每页条数
}

interface IOrderAmountStatParams {
    start_time: number // 开始时间戳（支持毫秒或秒）
    end_time: number // 结束时间戳（支持毫秒或秒）
    product?: string // 产品名（模糊匹配）
    username?: string // 用户名（模糊匹配）
    pay_type?: string // 支付方式（精确匹配）
    status?: number // 订单状态：0-未支付，1-已支付
}

interface IOrderAmountStatByIntervalParams {
    start_time: number // 开始时间戳（支持毫秒或秒）
    end_time: number // 结束时间戳（支持毫秒或秒）
    time_diff: number // 时间差（秒），用于判断统计粒度
    product?: string // 产品名（模糊匹配）
    username?: string // 用户名（模糊匹配）
    pay_type?: string // 支付方式（精确匹配）
    status?: number // 订单状态：0-未支付，1-已支付
}

interface IContactLogsParams {
    user_id: string // 牛媒用户 id
    page_index?: number // 第几页
    page_size?: number // 每页条数
}

interface IContactsExportParams {
    reporter_id?: string // 记者id
    created_at_gte?: string // 创建时间大于等于
    created_at_lte?: string // 创建时间小于等于
    status?: string // 跟进状态 1:未跟进 2:跟进中 3:跟进完成 4:无需跟进
    type?: string // 联系事由 1:报料 2:邀请
    cert_status?: string // 记者的认领状态 0：未认领 1：已认领
    user_id?: string // 用户id
    query?: string // 搜索内容
    reporter_name?: string // 记者名
    paid?: string // 是否付费报料 0:否 1:是
    province?: string // 省
    city?: string // 市
}

class ContactService {
    /** 获取联系列表 */
    public async getContacts(params: IGetContactsParams) {
        const result = await xhr({
            method: 'get',
            url: '/contact/list',
            params: params
        })
        return result
    }

    /** 获取联系详情 */
    public async getContact(params: IGetContactParams) {
        const result = await xhr({
            method: 'get',
            url: '/contact',
            params: params
        })
        return result
    }

    /** 修改爆料信息 */
    public async updateContact(params: IUpdateContactParams) {
        const result = await xhr({
            method: 'put',
            url: '/contact/update',
            params: params
        })
        return result
    }

    /** 推送报料给记者 */
    public async pushToReporter(params: IPushToReporterParams) {
        const result = await xhr({
            method: 'post',
            url: '/push_report',
            params: params
        })
        return result
    }

    /** 推送报料给记者 */
    public async getOrderList(params: IGetOrderListParams) {
        const result = await xhr({
            method: 'get',
            url: '/order/list',
            params: params
        })
        return result
    }

    /** 获取联系用户记录 */
    public async getContactLogs(params: IContactLogsParams) {
        const result = await xhr({
            method: 'get',
            url: '/nm_user/contact/list',
            params: params
        })
        return result
    }

    /** 导出联系申请 */
    public async exportContacts(params: IContactsExportParams) {
        const result = await xhr({
            method: 'post',
            url: '/contact/export',
            params: params
        })
        return result
    }

    /** 推送信息给用户 */
    public async sendMessageToUser(params: { id: number; content: string }) {
        const result = await xhr({
            method: 'post',
            url: '/contact/push_notice',
            params: params
        })
        return result
    }

    /** 订单总金额统计 */
    public async getOrderAmountStat(params: IOrderAmountStatParams) {
        const result = await xhr({
            method: 'get',
            url: '/order/amount_stat',
            params: params
        })
        return result
    }

    /** 按时间区间统计订单金额 */
    public async getOrderAmountStatByInterval(params: IOrderAmountStatByIntervalParams) {
        const result = await xhr({
            method: 'get',
            url: '/order/amount_stat_by_interval',
            params: params
        })
        return result
    }
}

// 实例化后导出，全局单例
export default new ContactService()
